// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    HTML_SITEMAP_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndexPage: action.htmlSitemapIndexPage
      };
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const htmlSitemapIndexQuery = get(
        currentState,
        'htmlSitemapIndex.data.query.queryString'
      );
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        htmlSitemapIndexQuery,
        'htmlSitemapIndexPage'
      );

      return {
        isLoading: false,
        data: action.htmlSitemapIndexPage,
        ads: adModelData
      };
    },
    HTML_SITEMAP_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
